import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../../api';
import { ArchivDropdownList, Filter } from './state';
import { mutations } from './mutations';
import { NAME, CRUMB_LABEL_KEY } from '../../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: new ArchivDropdownList(),
	filter: { ...new Filter() },
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: mutations,
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
